module.exports = __webpack_public_path__ + "media/images/animations/number_of_tires/3-84a6e935038915bc37b261b248c34097.png";